export const FETCH_ALARM_DATA = 'FETCH_ALARM_DATA';
export const FETCH_ALARM_EVENT_DATA = 'FETCH_ALARM_EVENT_DATA';
export const EXPORT_ALARM_DATA = 'EXPORT_ALARM_DATA';
export const FETCH_ALARM_COUNT_DATA = 'FETCH_ALARM_COUNT_DATA';
export const FETCH_ALARM_EVENT_COUNT_DATA = 'FETCH_ALARM_EVENT_COUNT_DATA';
export const CLEAR_ALARM_DATA = 'CLEAR_ALARM_DATA';
export const SET_ALARM_HISTORY_TABLE_PROPS = 'SET_ALARM_HISTORY_TABLE_PROPS';
export const SET_ACTIVE_ALARM_TABLE_PROPS = 'SET_ACTIVE_ALARM_TABLE_PROPS';
export const SET_FILTERS_APPLIED_FROM_REDIRECTION = 'SET_FILTERS_APPLIED_FROM_REDIRECTION';
export const SET_PULSE_ALARM_LOADER = 'SET_PULSE_ALARM_LOADER';
export const SET_ALARM_LIST_REQUEST_HASH = 'SET_ALARM_LIST_REQUEST_HASH';
export const SET_ALARM_LIST_CARDS_REQUEST_HASH = 'SET_ALARM_LIST_CARDS_REQUEST_HASH';
export const SET_PULSE_ALARM_LIST_LOADER = 'SET_PULSE_ALARM_LIST_LOADER';
